import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue' 
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import store from './store/index'

Vue.config.productionTip = false

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

// moment.js
import moment from 'vue-moment'
Vue.use(moment)

/*---------------Element UI------------------*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'
Vue.use(ElementUI, { locale })

/*---------------OAuth------------------*/
const HelloJs = require('hellojs/dist/hello.all.min.js');
const VueHello = require('vue-hellojs');
HelloJs.init({
  google: process.env.VUE_APP_GOOGLE_APP_CLIENT_ID,
  facebook: process.env.VUE_APP_FACEBOOK_APP_CLIENT_ID
}, {
  redirect_uri: '/authcallback'
});
Vue.use(VueHello, HelloJs);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
